import InputCode from './InputCode.jsx';

export default InputCode;